import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { BOOK_FORMATS } from 'containers/books/const';

import { Container, Image, Title, LabelWrap, Label, IconWrap } from './styles';

const BookItem = ({ id, image, title, format, formats }) => {
  const { t } = useTranslation('books');
  const icons = useMemo(() => formats || [format], [format, formats]);

  return (
    <Container to={`/books/${id}`}>
      <Image src={image} alt={t(title)} />
      <LabelWrap>
        {icons.map((key) => {
          const { name, icon: Icon, iconColor } = BOOK_FORMATS[key] || {};

          return (
            <Label key={key}>
              <IconWrap $color={iconColor}>
                <Icon />
              </IconWrap>
              <span>{t(name)}</span>
            </Label>
          );
        })}
      </LabelWrap>
      <Title>{t(title)}</Title>
    </Container>
  );
};

BookItem.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  formats: PropTypes.arrayOf(PropTypes.string),
};

BookItem.defaultProps = {
  formats: null,
};

export default BookItem;
